export default {
  mapLeftClick: {
    'placeInfo': 'Hely adatai',
    'placeInsidePolygon': 'Sokszögön belüli hely',
    'polygonArea': 'Sokszög területe',
    'copyLnglat': 'Hossz., szél. másolás',
    'copyLatlng': 'Szél., hossz. másolás',
    'directionsToClickedPoint': 'Kattintson az irányok gombra, hogy a ponthoz útvonalat tervezzen',
    'lnglatCopied': 'Hosszúság és szélesség kimásolva',
    'latlngCopied': 'Szélesség és hosszúság kimásolva'
  }
}
